import Navbar from '../components/Navbar';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useState } from 'react';

// import { createTheme } from '@mui/material/styles';

export default function Home () {
  const [myMode,setMymode] = useState("light");

  const darkTheme = createTheme({
    palette: {
      mode: myMode,
    },
  });
    return (
    <>
    <Navbar className="nav-cont" setMymode={setMymode}/>
    <Header/>
     <Footer/>
    </>
);
}